import axios from "axios";
import { API_ONBOARD_URL, API_ROUTES_ONBOARD } from "config/apiConfig";
import { Dispatch } from "redux";

// Define Action Types
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

// Define Action Creators
export const loginUser = (username: string, password: string) => async (dispatch: Dispatch) => {
  try {
 

    const response = await axios.post(
        `${API_ONBOARD_URL}${API_ROUTES_ONBOARD.AdminUser}login/`,
        { username, password }, // Send as JSON body
        { headers: { "Content-Type": "application/json" } } // Set correct headers
      );

    if (response.status === 200) {
      dispatch({ type: LOGIN_SUCCESS, payload: { username } });
    }
  } catch (error) {
    dispatch({ type: LOGIN_FAILURE, payload: "Invalid credentials" });
  }
};

export const logoutUser = () => ({
  type: LOGOUT,
});
